import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../js/coreRuntime.mjs';
import { KTypeParameter1s8efufd4mbj5 as KTypeParameter } from './KTypeParameter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { KClass1cc9rfeybg8hs as KClass } from './KClassJs.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../text/StringBuilderJs.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
import { _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx } from '../Char.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KTypeImplClass;
function KTypeImpl() {
  if (KTypeImplClass === VOID) {
    class $ {
      constructor(classifier, arguments_0, isMarkedNullable) {
        this.g1_1 = classifier;
        this.h1_1 = arguments_0;
        this.i1_1 = isMarkedNullable;
      }
      j1() {
        return this.g1_1;
      }
      k1() {
        return this.h1_1;
      }
      l1() {
        return this.i1_1;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        if (other instanceof KTypeImpl()) {
          tmp_1 = equals(this.g1_1, other.g1_1);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = equals(this.h1_1, other.h1_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.i1_1 === other.i1_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.g1_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        return imul(imul(tmp$ret$0, 31) + hashCode(this.h1_1) | 0, 31) + getBooleanHashCode(this.i1_1) | 0;
      }
      toString() {
        var tmp0_subject = this.g1_1;
        var tmp;
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, KClass()) : false) {
          var tmp1_elvis_lhs = this.g1_1.n1();
          tmp = tmp1_elvis_lhs == null ? this.g1_1.o1() : tmp1_elvis_lhs;
        } else {
          if (!(tmp0_subject == null) ? isInterface(tmp0_subject, KTypeParameter()) : false) {
            tmp = this.g1_1.m1();
          } else {
            tmp = null;
          }
        }
        var tmp2_elvis_lhs = tmp;
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          return '???';
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        var classifierString = tmp_0;
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().q1();
        this_0.r1(classifierString);
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.h1_1.s1()) {
          this_0.t1(_Char___init__impl__6a9atx(60));
          var iterator = this.h1_1.u1();
          var index = 0;
          while (iterator.v1()) {
            var index_0 = index;
            index = index + 1 | 0;
            var argument = iterator.w1();
            if (index_0 > 0) {
              this_0.r1(', ');
            }
            this_0.x1(argument);
          }
          this_0.t1(_Char___init__impl__6a9atx(62));
        }
        if (this.i1_1) {
          this_0.t1(_Char___init__impl__6a9atx(63));
        }
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'KTypeImpl');
    KTypeImplClass = $;
  }
  return KTypeImplClass;
}
//region block: exports
export {
  KTypeImpl as KTypeImpl24ni3lyofhkxw,
};
//endregion

//# sourceMappingURL=KTypeImpl.mjs.map
